//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: false,
      default: () => 1,
    },
  },
  data: ({value}) => ({
    formData: {
      current: value,
    },
    timerId: null,
  }),
  computed: {
    numericCurrent: {
      get() {
        switch (typeof this.formData.current) {
          case 'number':
            return this.formData.current;
          case 'string':
            return this.formData.current.length > 0 ? Number.parseInt(this.formData.current, 10) : 0;
          default:
            return 0;
        }
      },
      set(val) {
        this.formData.current = val;
      },
    },
  },
  watch: {
    value(newVal) {
      if (this.numericCurrent !== newVal) {
        this.numericCurrent = newVal;
      }
    },
  },
  beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    movePage(moveToLeft) {
      if (moveToLeft && this.numericCurrent > 1) {
        this.numericCurrent--;
      } else if (!moveToLeft && this.numericCurrent < this.total) {
        this.numericCurrent++;
      }
    },
    updateCurrentPage(e) {
      let number = 0;
      switch (typeof e.current) {
        case 'number':
          number = e.current;
          break;
        case 'string':
          if (e.current.length > 0) {
            number = Number.parseInt(e.current, 10);
          }
          break;
      }
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        if (number !== this.value) {
          this.$emit('input', number);
        }
      }, 200);
    },
  },
};
